import React, { useEffect } from "react";
import { LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { useHistory, useParams } from "react-router";
import { getQuoteDefaultPath } from "constants/quoteAction";
import { LIST_QUOTE_ITEM_QUERY } from "features/quotes/queries";

function QuoteDefaultRoute() {
  const history = useHistory();
  const { quoteId } = useParams();

  const { loading, data } = useQueryWithErrorHandling(LIST_QUOTE_ITEM_QUERY, {
    variables: { quoteId: parseInt(quoteId) },
  });
  const listQuoteItem = data?.listQuoteItem;

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!listQuoteItem?.quoteId) {
      history.push({ pathname: `/overview`, state: { quoteId } });
      return;
    }
    const pathname = getQuoteDefaultPath(quoteId, listQuoteItem.nextActionId);
    history.push({ pathname });
  }, [listQuoteItem?.nextActionId, listQuoteItem?.quoteId, loading, quoteId, history]);

  if (loading) {
    return <LoadingFakeText lines={10} />;
  }

  return <></>;
}

QuoteDefaultRoute.propTypes = {};

export default QuoteDefaultRoute;
